(function() {
	'use strict';
	angular.module('app.core')
		.directive('leanMultiSelect', leanMultiSelect);
	
	leanMultiSelect.$inject = ['$timeout', 'leanFilterService'];
	function leanMultiSelect($timeout, leanFilterService) {
		var html = '' +
			'<div class="multiselect-menu {{filterDynamicWidth==\'true\'?\'dynamic-width\':\'\'}}" ' +
				'ng-show="$parent.filterFunctions.getViewValues().visibleMenu == \'{{filterId}}\'" ng-click="$event.stopPropagation();" ' +
			'>' +
				'<div class="multiselect-header">' +
					'<div class="multiselect-title">' + 
						'<span translate> {{filterName}}</span>' +
						'<p ng-if="showFilterDetail" class="multiselect-detail" translate>{{filterDetail}}</p>' +
					'</div>' +
					'<div class="multiselect-search" ng-click="$event.stopPropagation();">' +
						'<input placeholder="{{\'Search...\'|translate}}" ng-model="$parent.filterSearch" ng-change="applySearch()" class="filter-menu-search">' +
					'</div>' +
					'<ul class="filter-menu multiselect-select-all">' +
						'<li ng-click="$event.stopPropagation();">' +
							'<a class="filterOption" ' +
								'ng-show="noneVisibleSelected" ' +
								'ng-click="!readOnly && toggleAll()" ng-disabled="readOnly">' +
									'<i class="fa fa-fw fa-lg fa-square-o" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}"></i>' +
									'{{"(" + numberSelected + " "}}' +
									'<span translate>selected</span>' +
									'{{")"}}' +
							'</a>' +
							'<a class="filterOption" ' +
								'ng-show="!noneVisibleSelected && allVisibleSelected" ' +
								'ng-click="!readOnly && toggleAll()" ng-disabled="readOnly">' +
									'<i class="fa fa-fw fa-lg fa-check-square" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}"></i>' +
									'{{"(" + numberSelected + " "}}' +
									'<span translate>selected</span>' +
									'{{")"}}' +
							'</a>' +
							'<a class="filterOption" ' +
								'ng-show="!allVisibleSelected && !noneVisibleSelected" ' +
								'ng-click="!readOnly && toggleAll()" ng-disabled="readOnly">' +
									'<i class="fa fa-fw fa-lg fa-minus-square" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}"></i>' +
									'{{"(" + numberSelected + " "}}' +
									'<span translate>selected</span>' +
									'{{")"}}' +
							'</a>' +
						'</li>' +
					'</ul>' +
				'</div>' +
				'<div class="multiselect-options" ' +
					'uib-tooltip="{{sharedViewTooltip}}" tooltip-placement="top" tooltip-class="react-style-tooltip" tooltip-enable="readOnly" tooltip-append-to-body="true"' +
				'>' +
					'<div class="filter-menu" ' +
						'ng-if="filterList.length > 0 && filteredModel.length == 0" ' +
						'style="padding-top:12px; padding-bottom:11px; padding-left:32px; padding-right:8px; color:#757575; font-style:italic" ' +
						'translate>' +
							'No options found' +
					'</div>' +
					'<div ng-show="modelStart > 0" style="text-align: center; padding-top: 8px">' +
						'<a ng-click="showMore(-maxVisibleOptions)">' +
							'<i class="fa fa-fw fa-lg fa-caret-left" ng-hide="item.selected"></i>' +
							'<span translate>Show previous</span> {{maxVisibleOptions | number:0}}' +
						'</a>' +
					'</div>' +
					'<div ng-if="filterGroupKey && group.length > 0" ng-repeat="(key, group) in groupedVisibleModel | orderObject: true track by key" class="multiselect-group-block">' +
							'<div class="ui-select-choices-group-label dropdown-header" translate>{{ filterGroupLabels[key] }}</div>' +
							'<ul class="filter-menu">' +
								'<li ng-repeat="item in group track by item[comparisonKey]" ng-class="item.class">' +
									'<a class="filterOption flexed" ng-attr-title="{{getItemLabel(item)}}" ng-click="$event.stopPropagation();!readOnly && toggleItem(item)" ng-disabled="readOnly">' +
										'<i class="fa fa-fw fa-lg fa-square-o" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}" ng-hide="item.selected"></i>' +
										'<i class="fa fa-fw fa-lg fa-check-square" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}" ng-show="item.selected"></i>' +
										'<span class="text-label" ng-bind-html="getItemLabel(item) | translate"></span>' +
										'<span class="individual-exclam" ng-init="popoverOpened[item.id]=false"' + 
											'ng-mouseover="mouseOver(item.id)" ng-mouseleave="mouseLeave(item.id)" ng-click="handleInnerClick($event)">' + 
										'<span ng-show="item.dataSyncIssue"' + 
											'uib-popover-html="getTooltip(item)"' + 
											'popover-class="white-tooltip"' + 
											'popover-placement="right"' +
											'popover-trigger="none"' +
											'popover-is-open="popoverOpened[item.id]"' +
											'popover-popup-close-delay="100"' + 
											'ng-class="{\'hovered\': popoverOpened[item.id]}"' +
											'class="filter-tooltip">' +
											'<i class="fa fa-exclamation-circle"></i>' + 
											'</span></span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
					'</div>' +
					'<ul ng-if="!filterGroupKey" class="filter-menu" ng-show="visibleModel.length > 0">' +
						'<li ng-repeat="item in visibleModel track by item[comparisonKey]" ng-class="item.class">' +
							'<a class="filterOption flexed" ng-attr-title="{{getItemLabel(item)}}" ng-click="$event.stopPropagation();!readOnly && toggleItem(item)" ng-disabled="readOnly">' +
								'<i class="fa fa-fw fa-lg fa-square-o" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}" ng-hide="item.selected"></i>' +
								'<i class="fa fa-fw fa-lg fa-check-square" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}" ng-show="item.selected"></i>' +
								'<span class="text-label" ng-bind-html="getItemLabel(item) | translate"></span>' +
								'<span class="individual-exclam" ng-init="popoverOpened[item.id]=false"' + 
									'ng-mouseover="mouseOver(item.id)" ng-mouseleave="mouseLeave(item.id)" ng-click="handleInnerClick($event)">' + 
								'<span ng-show="item.dataSyncIssue"' + 
									'uib-popover-html="getTooltip(item)"' + 
									'popover-class="white-tooltip"' + 
									'popover-placement="right"' +
									'popover-trigger="none"' +
									'popover-is-open="popoverOpened[item.id]"' +
									'popover-popup-close-delay="100"' + 
									'ng-class="{\'hovered\': popoverOpened[item.id]}"' +
									'class="filter-tooltip">' +
									'<i class="fa fa-exclamation-circle"></i>' + 
									'</span></span>' +
							'</a>' +
						'</li>' +
					'</ul>' +
					'<div ng-show="modelStart + maxVisibleOptions < filteredModel.length" style="text-align: center; padding-bottom: 8px">' +
						'<a ng-click="showMore(maxVisibleOptions)">' +
							'<span translate>Show next</span> {{maxVisibleOptions < filteredModel.length - modelStart - maxVisibleOptions ? maxVisibleOptions : filteredModel.length - modelStart - maxVisibleOptions | number:0}}' +
							'<i class="fa fa-fw fa-lg fa-caret-right" ng-hide="item.selected"></i>' +
						'</a>' +
					'</div>' +
				'</div>' +
				'<div class="shared-filter-footer" ng-show="!!sharedFilterText">' +
					'<ng-include class="info-icon" src="\'/application/library/ui_images/svg_icons/info-circle-light.svg\'"></ng-include>' +
					'<span translate>{{sharedFilterText}}</span>' +
				'</div>' +
				'<div class="multiselect-footer" ng-show="!readOnly">' +
					'<button class="button flat colored innerButton" ng-click="$parent.filterFunctions.cancelSelection()">' +
						'<span translate>Cancel</span>' +
					'</button>' +
					'<button class="button flat colored innerButton" data-testid="reportFilter-' + '{{filterId}}' + '-apply-btn" ng-disabled="$parent.filterFunctions.isReadOnly()" ng-click="$parent.filterFunctions.applySelection($event, filterId)">' +
						'<span translate>Apply</span>' +
					'</button>' +
				'</div>' +
			'</div>';
		return {
			restrict:'EA',
			template: html,
			replace:true,
			transclude: true,
			scope: {
				comparisonKey: '@',
				filterName: '@',
				filterDetail: '@',
				filterList: '=',
				filterLabel: '@',
				filterId: '@',
				filterGroupKey: '@',
				filterGroupLabels: '=',
				undefinedMap: '@',
				filterDynamicWidth: '@'
			},
			link: function(scope, element, attrs) {
				scope.comparisonKey = scope.comparisonKey || leanFilterService.getComparisonKey(scope.filterId);
				scope.maxVisibleOptions = 10;
				scope.filteredModel = scope.filterList;
				scope.modelStart = 0;
				scope.visibleModel = scope.filteredModel.slice(scope.modelStart, scope.maxVisibleOptions);
				updateGroupModel();
				scope.readOnly = scope.$parent.filterFunctions.isReadOnly();
				scope.showFilterDetail = !_.isEmpty(scope.filterDetail);
				if (!scope.$parent.filterFunctions.excludeSharedFilterText) {
					setSharedFilterText();
				}
				updateVisible();
				scope.popoverOpened = {};

				var timeoutCanceler = {};

				scope.applySearch = applySearch;
				scope.updateVisible = updateVisible;
				scope.getItemLabel = getItemLabel;
				scope.getTooltip = getTooltip;
				scope.toggleItem = toggleItem;
				scope.toggleAll = toggleAll;
				scope.showMore = showMore;
				scope.mouseOver = mouseOver;
				scope.mouseLeave = mouseLeave;
				scope.handleInnerClick = handleInnerClick;

				$timeout(function() {
					// first 10 are already displayed very fast
					// expand to 250 after it appears which will finish by
					// the time the user's mouse gets to the list
					scope.maxVisibleOptions = 250;
					scope.visibleModel = scope.filteredModel.slice(scope.modelStart,
						scope.modelStart + scope.maxVisibleOptions);
					updateGroupModel();
				}, 100);

				function applySearch() {
					scope.filteredModel = scope.$parent.filterFunctions.getFilteredModel(
						scope.filterList, scope.$parent.filterSearch);
					scope.modelStart = 0;
					scope.visibleModel = scope.filteredModel.slice(scope.modelStart, scope.maxVisibleOptions);
					updateGroupModel();
					scope.updateVisible();
				}

				function updateVisible() {
					scope.$parent.filterFunctions.updateVisibleAllOrNone(scope.filteredModel);
					var viewValues = scope.$parent.filterFunctions.getViewValues();
					scope.allVisibleSelected = viewValues.allVisibleSelected;
					scope.noneVisibleSelected = viewValues.noneVisibleSelected;
					scope.numberSelected = viewValues.numberSelected;
				}

				function showMore(offset) {
					scope.modelStart += offset;
					if (scope.modelStart < 0) {
						scope.modelStart = 0;
					} else if (scope.modelStart > scope.filteredModel.length - scope.maxVisibleOptions) {
						scope.modelStart = scope.filteredModel.length - scope.maxVisibleOptions;
					}
					scope.visibleModel = scope.filteredModel.slice(scope.modelStart,
						scope.modelStart + scope.maxVisibleOptions);
					updateGroupModel();
					jQuery('div.multiselect-options').first().scrollTop(0);
				}

				function getItemLabel(item) {
					var val = scope.$eval(scope.filterLabel, item);
					if (scope.undefinedMap) {
						val = JSON.parse(scope.undefinedMap)[val] || val;
					}
					return val;
				}

				function getTooltip(item) {
					return leanFilterService.getDataSyncIssueTooltip(1, 1);
				}

				function toggleItem(item) {
					if (scope.readOnly) return;
					scope.$parent.filterFunctions.toggleItem(item);
					updateVisible();
				}

				function mouseOver(siteId) {
					timeoutCanceler[siteId] && $timeout.cancel(timeoutCanceler[siteId]);
					timeoutCanceler[siteId] = $timeout(function () {
						scope.popoverOpened[siteId] = true;
					}, 100);
				};

				function mouseLeave(siteId) {
					timeoutCanceler[siteId] && $timeout.cancel(timeoutCanceler[siteId]);
					timeoutCanceler[siteId] = $timeout(function () {
						scope.popoverOpened[siteId] = false;
					}, 100);
				}

				function mouseLeaveAll() {
					for (var key in timeoutCanceler) {
						mouseLeave(key);
					}
				}

				function handleInnerClick(evt) {
					evt.stopPropagation();
					if (evt.target.className && 
						(evt.target.className.indexOf('tooltip-close') >= 0
							|| evt.target.className.indexOf('fa-times') >= 0)) {
						mouseLeaveAll();
					}
				}

				function toggleAll() {
					scope.$parent.filterFunctions.toggleAll(scope.$parent.filterSearch);
					updateVisible();
				}

				function setSharedFilterText() {
					var isPartialReportAccess = scope.$parent.filterFunctions.getReportAuthorizationLevel() === 'PARTIAL';
					var isPartialAccessFilter = leanFilterService.getAuthorizationLevel(scope.filterId) === 'PARTIAL';
					var isHierarchicalFilter = leanFilterService.getFilterById(scope.filterId).authz.indexOf('factoryHierarchy') !== -1;
					var isPartialAccessHierarchicalFilter = isPartialReportAccess && isHierarchicalFilter;
					var isSharedReport = scope.$parent.filterFunctions.getNumberOfSaves() > 0;

					if (scope.readOnly) {
						scope.sharedViewTooltip = 'Filters can’t be changed on shared views. Make a copy to create an editable version.';
					}

					if (isPartialAccessHierarchicalFilter) {
						scope.sharedFilterText = 'This shared view includes sites you don’t have access to.';
					} else if (isPartialAccessFilter) {
						scope.sharedFilterText = 'This shared view includes filters that aren’t available at your sites.';
					} else if (isSharedReport) {
						if (isHierarchicalFilter) {
							scope.sharedFilterText = 'Shared view users only see data for sites they have access to.';
						} else {
							scope.sharedFilterText = 'Filter changes are visible to all shared view users.';
						}
					}
				}

				function updateGroupModel() {
					if (scope.filterGroupKey) {
						scope.groupedVisibleModel = _.groupBy(scope.visibleModel, scope.filterGroupKey);
					}
				}
			}
		};
	}
})();
